<template>
  <div class="relative" v-if="havePermissions">
    <div :class="animating ? 'monitor-icon-anim' : ''">
      <div
        class="flex justify-center items-center w-full rounded-xl gap-3 px-4 text-white py-1 cursor-pointer transition-colors"
        :class="activeJob ? 'bg-blue-600' : 'bg-gray-300 opacity-50'"
        @click.stop="togglePanel"
      >
        <a-badge :dot="true" :offset="[2, -2]" v-if="activeJob">
          <a-icon
            type="download"
            :style="{ fontSize: '1.7em', color: 'white' }"
          ></a-icon>
        </a-badge>
        <a-icon
          v-else
          type="download"
          :style="{ fontSize: '1.7em', color: '#444a53' }"
        ></a-icon>
      </div>
    </div>

    <div
      v-if="showPanel"
      v-click-outside="() => (showPanel = false)"
      @mouseleave="showPanel = false"
      class="absolute bg-white rounded-lg right-0 monitor-panel shadow-2xl mt-4 z-50 overflow-hidden border border-gray-200"
    >
      <div class="p-4 border-b border-gray-100 bg-gray-50">
        <h3
          class="text-center font-bold text-gray-700 tracking-wider text-base mb-0"
        >
          Proceso de descarga
        </h3>
      </div>

      <div class="job-list p-4">
        <div v-if="!currentJob" class="text-center py-12 text-gray-400">
          <a-icon type="info-circle" class="text-3xl mb-3" /><br />
          No hay un proceso de descarga en curso
        </div>

        <div v-else class="job-item mb-4 pb-2">
          <div class="flex items-start gap-3">
            <div class="mt-1">
              <a-icon
                v-if="
                  currentJob.status !== 'finished' &&
                  currentJob.status !== 'error'
                "
                type="hourglass"
                theme="twoTone"
                class="text-2xl"
              />
              <a-icon
                v-else-if="currentJob.status === 'finished'"
                type="check-circle"
                theme="twoTone"
                two-tone-color="#52c41a"
                class="text-2xl"
              />
              <a-icon
                v-else-if="currentJob.status === 'error'"
                type="close-circle"
                theme="twoTone"
                two-tone-color="#f5222d"
                class="text-2xl"
              />
            </div>

            <div class="flex-1">
              <div class="flex justify-between items-start mb-1">
                <span
                  class="font-semibold text-sm text-gray-800 leading-tight"
                  >{{ currentJob.name }}</span
                >
                <a-icon
                  v-if="
                    currentJob.status === 'finished' ||
                    currentJob.status === 'error'
                  "
                  type="close"
                  class="text-xs text-gray-400 cursor-pointer hover:text-red-500 transition-colors"
                  @click="removeJob()"
                />
              </div>

              <div class="mb-2 mt-2">
                <a-progress
                  :percent="currentJob.percent"
                  size="small"
                  :status="
                    currentJob.status === 'error'
                      ? 'exception'
                      : currentJob.status === 'finished'
                      ? 'success'
                      : 'active'
                  "
                  :stroke-width="10"
                />
              </div>

              <div class="text-xs text-gray-500 font-medium">
                {{ currentJob.processed }} de {{ currentJob.total }} archivo(s)
                anexo(s) procesado(s)
              </div>

              <div class="mt-4" v-if="activeJob">
                <a-button
                  size="small"
                  type="danger"
                  ghost
                  class="px-2 h-7 text-xs"
                  @click="cancelJob(currentJob)"
                >
                  Cancelar
                </a-button>
              </div>
              
              <!-- <div class="text-xs text-gray-500 flex justify-between items-center">
                <span class="max-w-[180px] truncate font-medium">{{ currentJob.text }}</span>
                <div class="flex gap-2">
                  <a-button v-if="currentJob.url" size="small" type="primary" ghost class="px-2 h-7 text-xs" @click="downloadAgain(currentJob)">
                    Descargar
                  </a-button>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebase/config";
import { doc, onSnapshot } from "firebase/firestore";
import SharedServicesImpl from "../../../feature/shared/data/services/shared_services_impl";

export default {
  name: "AsyncProcessMonitor",
  data() {
    return {
      showPanel: false,
      currentJob: null,
      animating: false,
      userId: null,
      unsubscribe: null
    };
  },
  computed: {
    havePermissions() {
      return this.$store.state.session.user;
    },
    activeJob() {
      return this.currentJob && this.currentJob.status !== 'finished' && this.currentJob.status !== 'error';
    }
  },
  created() {
    this.userId = this.$store.state.session.user?.id;
    this.$root.$on("start-async-process", this.handleNewProcess);
    this.$root.$on("stop-async-process", this.removeJob);
    this.$root.$on("close-async-monitor", () => {
      this.showPanel = false;
    });
  },
  beforeDestroy() {
    this.$root.$off("start-async-process", this.handleNewProcess);
    this.$root.$off("stop-async-process", this.removeJob);
    this.$root.$off("close-async-monitor");
    if (this.unsubscribe) this.unsubscribe();
  },
  methods: {
    togglePanel() {
      this.showPanel = !this.showPanel;
      if (this.showPanel) {
        this.$root.$emit("close-notifications");
      }
    },
    handleNewProcess(payload) {
      const { docId, name, type } = payload;
      if (!docId) return;

      // Si ya hay un listener activo, lo limpiamos para el nuevo proceso (política de uno a la vez)
      if (this.unsubscribe) {
        this.unsubscribe();
        this.unsubscribe = null;
      }

      this.animating = true;
      setTimeout(() => (this.animating = false), 2000);

      this.setupJobListener(docId, name, type);
    },
    setupJobListener(docId, name, type) {
      const uId = String(this.userId).trim();
      const dId = String(docId).trim();

      let docPath = `sfc-annex-compression/${uId}/jobs/${dId}`;
      const docRef = doc(db, docPath);

      this.unsubscribe = onSnapshot(
        docRef,
        (snap) => {
          if (!snap.exists()) return;

          const data = snap.data();
          const processed = Number(data.processed_files) || 0;
          const total = Number(data.count) || 0;
          const percent = total
            ? Math.round((processed / total) * 100)
            : data.status === "finished"
            ? 100
            : 0;

          const jobName =
            name ||
            (type === "habeas-data"
              ? "Descarga de anexos - Habeas Data"
              : "Descarga de anexos - Derechos de Petición");

          let statusText = "";
          if (data.status === "finished") {
            statusText = "Proceso completado";
          } else if (data.status === "error") {
            statusText = "Error en el proceso";
          } else {
            statusText = `Procesando ${processed} de ${total} archivos`;
          }

          this.currentJob = {
            id: dId,
            name: jobName,
            status: data.status,
            processed,
            total,
            percent,
            text: statusText,
            url: data.url,
          };

          if (data.status === "finished" || data.url) {
            this.handleJobFinished(dId, this.currentJob);
          }
        },
        (error) => {
          console.error("Error en listener de monitor:", error);
        }
      );
    },
    handleJobFinished(id, job) {
      this.$root.$emit("async-process-finished", { id, ...job });

      if (job.url && !window[`global_downloaded_${id}`]) {
        window[`global_downloaded_${id}`] = true;
        this.triggerDownload(job.url, `anexos_${id}.zip`);
        this.$notification.success({
          message: "Descarga Lista",
          description: `El proceso "${job.name}" ha finalizado y la descarga ha comenzado.`,
        });
      }
    },
    triggerDownload(url, filename) {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadAgain(job) {
      if (job.url) {
        this.triggerDownload(job.url, `anexos_${job.id}.zip`);
      }
    },
    async cancelJob(job) {
      const payload = {
        document_id: job.id,
      };

      try {
        const response = await SharedServicesImpl.cancelCompressJob(payload);

        if (response.isSuccess) {
          this.$notification.info({
            message: "Resultado",
            description: "Descarga cancelada.",
          });
          this.$root.$emit("async-process-cancelled", { id: job.id });
          this.removeJob();
        } else {
          this.$notification.error({
            message: "Error",
            description:
              response.data?.message || "No se pudo cancelar la descarga.",
          });
        }
      } catch (error) {
        this.$notification.error({
          message: "Error",
          description: "Ocurrió un error interno al intentar cancelar.",
        });
      }
    },
    removeJob() {
      if (this.unsubscribe) {
        this.unsubscribe();
        this.unsubscribe = null;
      }
      if (this.currentJob) {
        const id = this.currentJob.id;
        this.currentJob = null;
        delete window[`global_downloaded_${id}`];
        delete window[`downloaded_${id}`];
      }
    },
  },
  directives: {
    "click-outside": {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            const callback =
              typeof binding.value === "function"
                ? binding.value
                : vnode.context[binding.expression];
            if (callback) callback(event);
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      },
    },
  },
};
</script>

<style scoped>
.monitor-panel {
  width: 24rem;
  z-index: 9999;
}

.job-list {
  max-height: 20rem;
  overflow-y: auto;
}

.monitor-icon-anim {
  animation: pulse-blue 2s infinite;
}

@keyframes pulse-blue {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.job-item >>> .ant-progress-inner {
  background-color: #f0f0f0;
}

.job-item >>> .ant-progress-bg {
  background: linear-gradient(90deg, #1890ff 0%, #096dd9 100%);
}
</style>
